import styled from "styled-components"

interface PopUpProps {
  navWidth: number
}

export const PopUp = styled.div<PopUpProps>`
  position: fixed;
  margin-left: ${({navWidth}) => `${navWidth.toString()}px`};
  width: ${({navWidth}) => `calc(100% - ${navWidth.toString()}px)`};
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: ${({theme}) => theme.colors.utility.white};
  box-shadow: ${({theme}) => theme.shadows.above.low};
`
